import { StyledSvg } from "baseui/icon";
import React from "react";

export const PreactIcon = (props: React.ComponentProps<typeof StyledSvg>) => {
  return (
    <StyledSvg viewBox="-256 -256 512 512" {...props}>
      <ellipse cx="0" cy="0" strokeWidth="16px" rx="75px" ry="196px" fill="none" stroke="#673ab8" transform="rotate(52.5)" />
      <ellipse cx="0" cy="0" strokeWidth="16px" rx="75px" ry="196px" fill="none" stroke="#673ab8" transform="rotate(-52.5)" />
      <circle cx="0" cy="0" r="34" fill="#673ab8" />
    </StyledSvg>
  );
};
